import CardSx from "./components/CardSx.jsx";
import SecondCardSx from "./components/SecondCardSx.jsx";
import ThirdCardSx from "./components/ThirdCardSx.jsx";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import Loading from "components/loading/Loading";
import axiosClient from "axios-client.js";

const ServerDetails = () => {
    const { code } = useParams();
    const [load, setLoad] = useState(false);
    const [message, setMessage] = useState({});
    const [state, setState] = useState(null);
    const [refetchIndex, setRefetchIndex] = useState(0);

    useEffect(() => {
        setLoad(true);
        setMessage({});
        axiosClient
            .get("/server/" + code)
            .then(({ data }) => {
                setLoad(false);
                setState(data);
            })
            .catch((err) => {
                const response = err.response;
                setLoad(false);
                if (response) {
                    setMessage({
                        text: response.data.message,
                        type: "ERROR",
                        errors: response.data.errors
                            ? response.data.errors
                            : {},
                    });
                }
            });
    }, [refetchIndex]);

    return (
        <div>
            {load ? <Loading /> : null}
            <div className="mt-5 grid grid-cols-1 gap-5">
                <div className="-mx-4 flex flex-wrap">
                    <div className="w-full px-4">
                        {message.hasOwnProperty("text") ? (
                            <div
                                className={
                                    "mb-6 text-left text-base " +
                                    (message.type === "SUCCESS"
                                        ? "text-green-500"
                                        : message.type === "ERROR"
                                        ? "text-red-500"
                                        : message.type === "WARNING"
                                        ? "text-amber-500"
                                        : null)
                                }
                            >
                                <p>{message.text}</p>
                            </div>
                        ) : null}
                        {state ? (
                            <div>
                                <div className="mb-6">
                                    <CardSx state={state.server} />
                                </div>
                                <div className="mb-6">
                                    <SecondCardSx
                                        state={state}
                                        setRefetchIndex={setRefetchIndex}
                                    />
                                </div>
                                <div className="mb-6">
                                    <ThirdCardSx state={state.customer} />
                                </div>
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ServerDetails;
